var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.955 20.795C16.7443 20.5841 16.6259 20.2982 16.6259 20C16.6259 19.7019 16.7443 19.416 16.955 19.205L21.197 14.9615C21.408 14.7506 21.6942 14.6321 21.9926 14.6322C22.1403 14.6322 22.2866 14.6614 22.4231 14.7179C22.5596 14.7745 22.6836 14.8574 22.7881 14.9619C22.8925 15.0664 22.9754 15.1905 23.0319 15.327C23.0884 15.4635 23.1175 15.6098 23.1174 15.7576C23.1174 15.9053 23.0883 16.0516 23.0317 16.1881C22.9751 16.3246 22.8922 16.4486 22.7877 16.553L19.3415 20L22.7885 23.4471C22.896 23.5508 22.9817 23.6749 23.0407 23.8121C23.0998 23.9493 23.1309 24.0969 23.1322 24.2463C23.1336 24.3957 23.1052 24.5438 23.0487 24.6821C22.9922 24.8204 22.9087 24.9461 22.8032 25.0517C22.6976 25.1574 22.572 25.241 22.4338 25.2976C22.2955 25.3543 22.1474 25.3828 21.998 25.3816C21.8487 25.3803 21.701 25.3494 21.5637 25.2905C21.4265 25.2316 21.3023 25.1459 21.1985 25.0386L16.9535 20.795H16.955Z",
    fill: "#2F2F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.e98ae33fb8785cb5181c260fd24136d2.svg";
export { ForwardRef as ReactComponent };